import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MigajasCategorias from "@components/MigajasCategorias";
import { useTranslation } from "@hooks/useTranslation";
import axios from "@fetch/axios";

const NuestrosArtistas = () => {
  const navigate = useNavigate();
  const { translate } = useTranslation();
  const [artists, setArtists] = useState([]);
  const [loading, setLoadingIg] = useState(true);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await axios.get(`/artist`);
        // Asegurarse de que la respuesta sea un array
        setArtists(response.data.data);
      } catch (error) {
        console.error("Error fetching Artist posts", error);
        setArtists([]);
      } finally {
        setLoadingIg(false);
      }
    };
    fetchPosts();
  }, []);

  const CategoryItem = (item, image, index) => {

    return (
      <article
        key={index}
        className="ImageButtonBG"
        style={{ backgroundImage: `url(${image})` }}
      >
        <div className="button-artist" onClick={() => navigate(`${item.uri}`)}>
            <img
              src={item.button_image}
              alt={"Logo del artista"}
              className="ArtistGridLogo"
              style={{
                width: "auto",
                height: "auto",
                maxWidth: "28rem",
                maxHeight: "12rem",
              }}
            />
        </div>
      </article>
    );
  };

  const LoadingCard = () => {
    const buttonPlaceholder = {
      width: "20%",
      height: 80,
      backgroundColor: "rgba(233, 227, 227, 0.65)",
      borderRadius: 6,
    };

    return (
      <>
        {Array.from({ length: 4 }).map((_, idx) => (
          <article
            key={idx}
            className="ImageButtonBG"
            style={{
              backgroundImage: "none",
              backgroundColor: "rgba(0, 0, 0, 0.44)",
              minHeight: 400,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 16,
            }}
          >
            <div style={buttonPlaceholder}></div>
          </article>
        ))}
      </>
    );
  };

  return (
    <>
      <MigajasCategorias nivel1={translate('categories.our_artists')} />
      {loading ? 
      <section className="CategoryBox">
        {LoadingCard()}
      </section>
      :
      <section className="CategoryBox">
        {artists.map((subcategory, index) => (
          CategoryItem(subcategory, subcategory.desktop_image, index)
        ))}
      </section>}
    </>
  );
};

export default NuestrosArtistas;
